export const requestList = (res) => {
  if (res.code === 200 && res.message === '成功' && res.data && res.data.length > 0) {
    return true;
  }
  return false;
};

export const verifyErrorToast = (err) => {
  if (err.errorFields && err.errorFields.length > 0) {
    return true;
  }
  return false;
};

export const requestCommon = (res) => {
  if (res.code === 200 && res.message === '成功') {
    return true;
  }
  return false;
};

export const requestUpdate = (res) => {
  if (res.code === 200 && res.message === '修改成功') {
    return true;
  }
  return false;
};

export const requestDelete = (res) => {
  if (res.code === 200 && res.message === '删除成功') {
    return true;
  }
  return false;
};
